import { Box, Button, Theme, Typography, TypographyTypeMap } from '@mui/material';
import { SxProps } from '@mui/system';
import { FC, RefObject } from 'react';
import { BreakpointProperties } from '../../../../hooks/useBreakpoint';
import { KeyboardNavigator } from '../../utility/keyboard-navigation';

export interface CfDataGridLoadMoreProps {
  keyboardNavigator: KeyboardNavigator;
  pageEndIndex: number;
  onNextPageRequested: (pageIndex: number) => void;
  breakpointProperties: BreakpointProperties;
  buttonRef?: RefObject<HTMLButtonElement>;

  sx?: SxProps<Theme>;
}

export const CfDataGridLoadMore: FC<CfDataGridLoadMoreProps> = (props: CfDataGridLoadMoreProps) => {
  const typographyTypeMap: TypographyTypeMap = { defaultComponent: 'span', props: {} };
  switch (props.breakpointProperties.breakpoint) {
    case 'xl':
      typographyTypeMap.props.variant = 'paragraphBold';
      break;
    default:
      typographyTypeMap.props.variant = 'mobileParagraphBold';
      break;
  }

  const handleClick = () => {
    const lastElement = props.keyboardNavigator.lastEnabledElement;
    if (lastElement) lastElement.focus();
    props.onNextPageRequested(props.pageEndIndex + 1);
  };

  return (
    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
      <Button
        variant='contained'
        color='secondary'
        onClick={handleClick}
        sx={{ width: 200, height: { xs: 40, xl: 32 }, ...props.sx }}
        ref={props.buttonRef}
        onKeyDown={(event) => {
          if (event.key === 'ArrowUp') {
            event.preventDefault();
            props.keyboardNavigator.lastEnabledElement?.focus();
          }
        }}
      >
        <Typography {...typographyTypeMap.props}>Load More</Typography>
      </Button>
    </Box>
  );
};
